var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  CardSummaryRealEstate: () => CardSummaryRealEstate
});
var import_cardSummary = __toModule(require("./cardSummary"));
const _CardSummaryRealEstate = class extends import_cardSummary.CardSummary {
  constructor(cardManager) {
    super(cardManager);
    this.cardManager = cardManager;
  }
  getYayoyakisSiblings() {
    const cards = this.cardManager.list(false);
    const yayoyakiY01031 = this.cardManager.getYayoyakisSiblings(this.getIndex()).find((yayoyaki) => yayoyaki.getId() === "Y01031");
    const yayoyakisSiblings = [];
    for (const card of cards) {
      if (card !== this && card.isChild()) {
        const cardYayoyakis = this.cardManager.getYayoyakisSiblings(card.getIndex());
        const cardYayoyaki = cardYayoyakis.find((yayoyaki) => yayoyaki.getId() === "Y01159");
        if (cardYayoyaki.getValue() === yayoyakiY01031.getValue()) {
          yayoyakisSiblings.push(card);
        }
      }
    }
    return yayoyakisSiblings;
  }
  getIcon() {
    return this.isChild() ? _CardSummaryRealEstate.ICON_CHILD : super.getIcon();
  }
  getYayoyakis() {
    return this.isChild() ? [] : super.getYayoyakis();
  }
  isChild() {
    const yayoyakis = this.cardManager.getYayoyakisSiblings(this.getIndex());
    const yayoyakiY01021 = yayoyakis.find((yayoyaki) => yayoyaki.getId() === "Y01021");
    if (yayoyakiY01021.getValue() !== "A") {
      return false;
    }
    const yayoyakiY01365 = yayoyakis.find((yayoyaki) => yayoyaki.getId() === "Y01365");
    const yayoyakiY01366 = yayoyakis.find((yayoyaki) => yayoyaki.getId() === "Y01366");
    const yayoyakiY01367 = yayoyakis.find((yayoyaki) => yayoyaki.getId() === "Y01367");
    if (yayoyakiY01365.getValue() && !yayoyakiY01366.getValue() || yayoyakiY01367.getValue()) {
      return true;
    }
    return false;
  }
  isFiltered() {
    return this.isChild() || super.isFiltered();
  }
};
let CardSummaryRealEstate = _CardSummaryRealEstate;
CardSummaryRealEstate.ICON_CHILD = "https://assets.taxdown.es/assets/screen/sections_icons_anexo.png";
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  CardSummaryRealEstate
});
